/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Filter_Approve_AllInputs */

const vi_tea_purchase_filter_approve_all = /** @type {(inputs: Tea_Purchase_Filter_Approve_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả`)
};

/**

* @param {Tea_Purchase_Filter_Approve_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_filter_approve_all = /** @type {((inputs?: Tea_Purchase_Filter_Approve_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Filter_Approve_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_filter_approve_all(inputs)
});